var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntegrations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layers-two-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M4.66732 7.99972L1.33398 9.66638L7.76214 12.8805C7.84959 12.9242 7.89332 12.9461 7.93919 12.9547C7.97981 12.9623 8.02149 12.9623 8.06212 12.9547C8.10798 12.9461 8.15171 12.9242 8.23917 12.8805L14.6673 9.66638L11.334 7.99972M1.33398 6.33305L7.76214 3.11897C7.84959 3.07525 7.89332 3.05338 7.93919 3.04478C7.97981 3.03716 8.02149 3.03716 8.06212 3.04478C8.10798 3.05338 8.15171 3.07525 8.23917 3.11897L14.6673 6.33305L8.23917 9.54713C8.15171 9.59085 8.10798 9.61272 8.06212 9.62132C8.02149 9.62895 7.97981 9.62895 7.93919 9.62132C7.89332 9.61272 7.84959 9.59085 7.76214 9.54713L1.33398 6.33305Z",
    stroke: "#01588C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrations);
export default __webpack_public_path__ + "static/media/integrations.7042095f2094885bec2d6521df0d0769.svg";
export { ForwardRef as ReactComponent };